module.exports = __webpack_public_path__ + "static/00013.07dec71e.jpg";